<style lang="scss" scoped>
.m-role {
	position: relative;
	width: 100%;
	height: 100%;
	overflow: hidden;
	background: url('../../assets/mobile/role-bg.png');
	background-size: 100% 100%;
}
.role {
	position: absolute;
	top: 0;
	width: 100%;
	height: auto;
}
.left-btn {
	position: absolute;
  	left: 8%;
  	top: 57vh;
	height: 7vh;
}
.right-btn {
	position: absolute;
	right: 8%;
	top: 57vh;
	height: 7vh;
}
.voice-block {
	position: absolute;
	bottom: 6vh;
	left: 4%;
	width: 94%;
	height: 13vh;
	background: url('../../assets/mobile/role-voice-bg.png');
	background-size: 100% 100%;
	.china-voice,
	.japan-voice {
		width: 86%;
		height: 5vh;
		margin-left: 12%;
		margin-top: 1vh;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		font-size: 12px;
		letter-spacing: 1px;
		.voicer {
			width: 22%;
			color: #5c4320;
		}
		.voice-btn {
			width: 10%;
		}
		.voice-word {
			color: #6a5521;
			transform: scale(0.9);
			width: 68%;
			height: 5vh;
			line-height: 2.5vh;
			overflow: hidden;
			display: flex;
			align-items: center;
			flex-wrap: wrap;
		}
	}
}
.slide-fade-enter-active {
	transition: all 2s ease;
}
.slide-fade-enter {
  opacity: 0.3;
}
</style>

<template>
<div class="m-role">
	<!-- 人物图 -->
	<template v-for="(item, index) in roleList" >
		<transition name="slide-fade" :key="item.figureId">
			<img 
				class="role" 
				v-show="index == roleChooseIndex" 
				:src="item.figureImagePath" 
				:alt="item.figureImageName"
			>
		</transition>
	</template>
	<img @click="goPreview" class="left-btn" src="../../assets/pc/left.png" alt="">
	<img @click="goNext" class="right-btn" src="../../assets/pc/right.png" alt="">
	<div class="voice-block">
		<div class="china-voice">
			<div class="voicer">{{roleChoose.figureVoiceNameZhong}}</div>
			<img @click="playChinaVoice" class="voice-btn" src="../../assets/pc/voice-btn.png" alt="">
			<div class="voice-word">{{roleChoose.figureVoiceTextZhong}}</div>
		</div>
		<audio :src="roleChoose.figureVoiceFilePathZhong" id="china_audio"></audio>
		<div class="japan-voice">
			<div class="voicer">{{roleChoose.figureVoiceNameRi}}</div>
			<img @click="playJapanVoice" class="voice-btn" src="../../assets/pc/voice-btn.png" alt="">
			<div class="voice-word">{{roleChoose.figureVoiceTextRi}}</div>
		</div>
		<audio :src="roleChoose.figureVoiceFilePathRi" id="japan_audio"></audio>
	</div>
</div>
</template>

<script>
export default {
	name:'m-role',
	computed: {
		roleChoose() {
			if(this.roleList.length > 0) {
				return this.roleList[this.roleChooseIndex];
			} else {
				return {
					figureVoiceNameRi: '',
					figureVoiceTextRi: '',
					figureVoiceNameZhong: '',
					figureVoiceTextZhong: ''
				}
			}
		}
	},
	data() {
		return {
			roleChooseIndex: 0,
			roleList: [],
			chinaVoiceRoot: null,
			japanVoiceRoot: null,
			timeInterval: null
		}
	},
	watch: {
		roleChooseIndex() {
			this.chinaVoiceRoot.load();
			this.japanVoiceRoot.load();
		}
	},
	mounted() {
		const width = document.body.clientWidth;
		if(width > 850) {
			this.$router.push({name: 'p-role'});
		} else {
			this.chinaVoiceRoot = document.getElementById('china_audio');
			this.japanVoiceRoot = document.getElementById('japan_audio');
			this.init();
		}
	},
	methods:{
		init() {
			this.$http.get('/api/website/getFigureInfo?platform=2').then((rsp) => {
				this.roleList = rsp.result.figures;
				this.interval();
			});
		},
		interval() {
			this.timeInterval = setInterval(() => {
				if(this.roleList.length <= 1) {
					clearInterval(this.timeInterval);
				} else {
					if(this.roleChooseIndex == this.roleList.length-1) {
						this.roleChooseIndex = 0;
					} else {
						this.roleChooseIndex ++;
					}
				}
			}, 10000);
		},
		clearInterval() {
			clearInterval(this.timeInterval);
		},
		goPreview() {
			if(this.roleChooseIndex == 0) {
				this.roleChooseIndex = this.roleList.length - 1;
			} else {
				this.roleChooseIndex --;
			}
		},
		goNext() {
			if(this.roleChooseIndex + 1 >= this.roleList.length) {
				this.roleChooseIndex = 0;
			} else {
				this.roleChooseIndex ++;
			}
		},
		playJapanVoice() {
			if(this.chinaVoiceRoot.played) {
				this.chinaVoiceRoot.pause();
			}
			if (this.japanVoiceRoot.paused) {
				this.japanVoiceRoot.play();
			} else {
				this.japanVoiceRoot.pause();
			}
		},
		playChinaVoice() {
			if(this.japanVoiceRoot.played) {
				this.japanVoiceRoot.pause();
			}
			if (this.chinaVoiceRoot.paused) {
				this.chinaVoiceRoot.play();
			} else {
				this.chinaVoiceRoot.pause();
			}
		}
	},
	beforeDestroy() {
		this.clearInterval();
	}
}
</script>